import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { fetchIssueArticles, fetchArticles } from '../../actions/articles';
import { changePage } from '../../actions/nav';
import { Grid, Toolbar, Paper, Button, IconButton } from '@material-ui/core';
import { Info, Facebook } from '@material-ui/icons';

const Issues = props => {
    const [ issues, setIssues ] = useState([]);
    const [ facebookShares, setFacebookShares ] = useState(0);

    useEffect(() => {
        const { id } = props.match.params;
        props.fetchArticles({reportId: id});
        props.fetchIssueArticles({reportId: id});
    }, [props.match.params.id]);

    useEffect(() => {
        props.changePage({
            page: props.report.name,
            image: props.report.image,
            breadcrumbs: [
                {
                    name: 'Dashboard',
                    path: '/'
                },
                {
                    name: 'Projects',
                    path: '/projects'
                },
                {
                    name: props.project.name,
                    path: `/projects/${props.project.id}/reports`
                }
            ],
            tabs: [
                'overview', 'articles', 'issues'
            ]
        });
    }, [props.report.id, props.project.id]);

    useEffect(() => {
        const issueErrors = props.issueArticles.reduce((prev, curr) => {
            const errors = _.flatten(Object.values(curr.issues.errors));
            return prev.concat(errors);
        }, []);
        setIssues(_.uniq(issueErrors));
    }, [props.issueArticles]);

    useEffect(() => {
        const shares = props.articles.reduce((prev, curr) => {
            if (curr.socialStats) {
                return prev + curr.socialStats.facebook_total;
            }
            return prev;
        }, 0);
        setFacebookShares(shares);
    }, [props.articles]);

    return (
        <Grid container spacing={0}>
            <Paper elevation={12}>
                <Toolbar className='info-bg'>
                    <IconButton className='white-text'>
                        <Info />
                    </IconButton>
                    <h2 className='headline'>Issues</h2>
                </Toolbar>
                <p>Article Issues</p>
                <p>{issues.length}</p>
                <Button color='primary' href={`/reports/${props.match.params.id}/issues`}>Fix Article Issues</Button>
            </Paper>
            <Paper elevation={12}>
                <Toolbar className='facebook-bg'>
                    <IconButton className='white-text'>
                        <Facebook />
                    </IconButton>
                    <h2 className='headline'>Facebook Shares</h2>
                </Toolbar>
                <p>{facebookShares}</p>
            </Paper>
        </Grid>
    );
};

Issues.propTypes = {
    fetchIssueArticles: PropTypes.func,
    issueArticles: PropTypes.array,
    fetchArticles: PropTypes.func,
    articles: PropTypes.array,
    match: PropTypes.object,
    changePage: PropTypes.func,
    report: PropTypes.object,
    project: PropTypes.object
};

function mapStateToProps (state) {
    const { issueArticles, articles, report } = state.articles.toJS();
    const { project } = state.projects.toJS();
    return { issueArticles, articles, report, project };
}
export default connect(mapStateToProps, {fetchIssueArticles, fetchArticles, changePage})(Issues);
